
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.btn.none {

  color: var(--idblab-gray-dark) !important
}

.btn.none:hover {

  color: var(--idblab-gray-dark) !important
}

.btn.none:focus {

  color: var(--idblab-gray-dark) !important
}

.btn.red {

  border-width: 0px !important;

  background-color: var(--neutral-transparent) !important;

  font-family: Open Sans, Helvetica, Arial, sans-serif !important;

  font-size: var(--fs-base) !important;

  line-height: var(--lh-base) !important;

  font-weight: var(--fw-bold) !important;

  color: var(--idblab-magenta-main) !important
}

.btn.red:hover {

  color: var(--idblab-magenta-lighten-1) !important
}

.btn.red:focus {

  color: var(--idblab-magenta-lighten-1) !important
}

.btn.red:hover, .btn.red:focus {

  color: var(--idblab-magenta-lighten-1) !important
}

.btn.red:hover {

  -webkit-text-decoration-line: underline;

          text-decoration-line: underline
}

.btn.red:focus {

  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;

  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;

  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), 0 0 #0000 !important;

  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important
}

.btn.red:focus {

  --tw-ring-color: var(--idblab-magenta-lighten-1) !important
}

.btn.red[aria-disabled='true'] {

  color: var(--gray-professional-lighten-2) !important
}

.btn.red[aria-disabled='true'] {

  -webkit-text-decoration-line: none !important;

          text-decoration-line: none !important
}

.btn.red[aria-disabled='true']:focus {

  color: var(--gray-professional-main) !important
}
`;